import type { InjectionKey } from 'vue';
import type { FeatureFlagService } from '../services/FeatureFlagService';

export const FEATURE_FLAG_SERVICE_KEY: InjectionKey<FeatureFlagService> = Symbol('featureFlagService');